/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import * as global from "../../js/global";
import * as helper from "../../js/helper";
import full_loading from "../components/full-loading.vue";
const __vue_script__ = {
    components: {
        full_loading: full_loading,
    },
    name: 'nafath_verification_modal',
    props: {
    },
    data() {
        return {
            global,
                helper,
                frappe,
            is_loading: false,
            error: false,
            national_id:"",
            random:null,
            attachment:null,
            imageUrl:null,
            filename:null,
            filetype:null,
            onsuccess_func:null
        }
    },
    mounted() {
        global.emitter.on("set-onsuccess-func", (args) => {
            onsuccess_func = args;
        });
        global.emitter.on("set-national-id", (args) => {
            this.national_id = args;
        });
        var exampleModal = document.getElementById('nafaz-verification-modal');
        exampleModal.addEventListener('show.bs.modal', ()=>{
            // this.national_id = "";
            this.random = null;
        });
    },
    methods: {
        verify_nafaz: async function (){
            if(this.national_id.length != 10 || !(/^\d+$/.test(this.national_id)) ){
                helper.showException("Enter valid National Id");
                return;
            }
            if(this.is_loading){
                return;
            }
            this.loading = true;
            global.emitter.emit("show-full-loading");
            let params = {
                national_id: this.national_id,
            };
            try {
                let res = await $.ajax({
                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                    url: "/api/method/maalek.api.verify_nafath",
                    type: "POST",
                    // data: params //for GET request
                    data: JSON.stringify(params) //for POST request
                });
                global.emitter.emit("hide-full-loading");
                this.random = res.message
                var status = "WAITING"
                do{
                    res = await $.ajax({
                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },
                        url: "/api/method/maalek.api.verify_nafath_wait",
                        type: "GET",
                        data: {} //for GET request
                    });
                    status = res.message
                }while(status == "WAITING");
                this.loading = false
                this.error = false;
                $("#nafaz-verification-modal").modal('hide');
                helper.showSuccess("Nafath verification is successful.",onsuccess_func);
            } catch (e) {
                this.error = true;
                helper.showException(e,()=>{
                    $("#nafaz-verification-modal").modal('hide');
                });
            }
            global.emitter.emit("hide-full-loading");
            this.loading = false
        },
        onPickFile () {
            this.$refs.fileInput.click()
        },
        onFilePicked (event) {
            const files = event.target.files
            if (files && files[0]) {
                this.attachment = {};
                this.attachment["file"] = files[0].name
                this.attachment["type"] = files[0].type
                const fileReader = new FileReader()
                fileReader.readAsDataURL(files[0])
                let reader = new FileReader;
                reader.onload = e => {
                    this.attachment["data"] = e.target.result;
                }
                reader.readAsDataURL(files[0]);
                this.$forceUpdate();
            }
        }
    },
    computed: {
    }
}

/* template */
var __vue_render__ = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "modal fade filter-popup-area",
      attrs: {
        id: "nafaz-verification-modal",
        "data-bs-backdrop": "static",
        "data-bs-keyboard": "false",
        tabindex: "-1",
        "aria-labelledby": "staticBackdropLabel",
        "aria-hidden": "true"
      }
    },
    [
      _c(
        "div",
        {
          staticClass:
            "modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable"
        },
        [
          _c("div", { staticClass: "modal-content p-4" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c(
                "h5",
                {
                  staticClass: "modal-title",
                  attrs: { id: "staticBackdropLabel" }
                },
                [_vm._v(_vm._s(_vm.helper.t("Nafath Verification")))]
              ),
              _vm._v(" "),
              _c("button", {
                staticClass: "btn-close",
                attrs: {
                  type: "button",
                  "data-bs-dismiss": "modal",
                  "aria-label": "Close"
                }
              })
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modal-body" }, [
              _vm.random == null
                ? _c(
                    "div",
                    { staticClass: "row text-center justify-content-center" },
                    [
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "To publish a property you must verify through Nafath."
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "col-6" }, [
                        _c("div", { staticClass: "form-group" }, [
                          _c("label", [
                            _vm._v(_vm._s(_vm.helper.t("National Id / Iqama")))
                          ]),
                          _vm._v(" "),
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.national_id,
                                expression: "national_id"
                              }
                            ],
                            staticClass: "form-control border-radius",
                            attrs: { type: "text", disabled: "" },
                            domProps: { value: _vm.national_id },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.national_id = $event.target.value
                              }
                            }
                          })
                        ])
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.random != null
                ? _c(
                    "div",
                    { staticClass: "row text-center justify-content-center" },
                    [
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            _vm.helper.t(
                              "To continue, please confirm the number from Nafath App"
                            )
                          )
                        )
                      ]),
                      _vm._v(" "),
                      _c("h1", { staticClass: "pt-5" }, [
                        _vm._v(_vm._s(_vm.random))
                      ])
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.random == null
                ? _c(
                    "div",
                    {
                      staticClass: "row text-center justify-content-center mt-2"
                    },
                    [
                      _c("div", { staticClass: "col-12" }, [
                        _c(
                          "div",
                          { staticClass: "d-flex justify-content-center" },
                          [
                            _vm.national_id
                              ? _c(
                                  "a",
                                  {
                                    staticClass: "btn btn-primary",
                                    attrs: { role: "button" },
                                    on: {
                                      click: function($event) {
                                        return _vm.verify_nafaz()
                                      }
                                    }
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(_vm._s(_vm.helper.t("Submit")))
                                    ])
                                  ]
                                )
                              : _vm._e()
                          ]
                        )
                      ])
                    ]
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ]
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-41ec3b89_0", { source: "\n.modal-content{\n    overflow: visible !important;\n}\n", map: {"version":3,"sources":["../maalek/maalek/public/vue/modal/nafath-verification.vue"],"names":[],"mappings":";AAyJA;IACA,4BAAA;AACA","file":"nafath-verification.vue","sourcesContent":["<template>\r\n    <div class=\"modal fade filter-popup-area\" id=\"nafaz-verification-modal\" data-bs-backdrop=\"static\" data-bs-keyboard=\"false\"\r\n        tabindex=\"-1\" aria-labelledby=\"staticBackdropLabel\" aria-hidden=\"true\">\r\n        <div class=\"modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable\">\r\n            <div class=\"modal-content p-4\">  \r\n                <div class=\"modal-header\">\r\n                    <h5 class=\"modal-title\" id=\"staticBackdropLabel\">{{ helper.t(\"Nafath Verification\") }}</h5>\r\n                    <button type=\"button\" class=\"btn-close\" data-bs-dismiss=\"modal\" aria-label=\"Close\"></button>\r\n                </div>\r\n                <div class=\"modal-body\">\r\n                    <div v-if=\"random == null\" class=\"row text-center justify-content-center\">\r\n                        <h5>{{ helper.t(\"To publish a property you must verify through Nafath.\") }}</h5>\r\n                        <div class=\"col-6\">\r\n                            <div class=\"form-group\">\r\n                                <label>{{ helper.t(\"National Id / Iqama\") }}</label>\r\n                                <input v-model=\"national_id\" type=\"text\" class=\"form-control border-radius\" disabled>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                    <div v-if=\"random != null\" class=\"row text-center justify-content-center\">\r\n                        <h5>{{ helper.t(\"To continue, please confirm the number from Nafath App\") }}</h5>\r\n                        <h1 class=\"pt-5\">{{ random }}</h1>\r\n                    </div>\r\n                    <div v-if=\"random == null\" class=\"row text-center justify-content-center mt-2\">\r\n                        <div class=\"col-12\">\r\n                            <div class=\"d-flex justify-content-center\">\r\n                                <a v-if=\"national_id\" class=\"btn btn-primary\"\r\n                                    role=\"button\"\r\n                                    @click=\"verify_nafaz()\">\r\n                                    <p>{{ helper.t(\"Submit\") }}</p>\r\n                                </a>\r\n                            </div>\r\n                        </div>\r\n                    </div>\r\n                </div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</template>\r\n\r\n<script>\r\nimport * as global from \"../../js/global\";\r\nimport * as helper from \"../../js/helper\";\r\nimport full_loading from \"../components/full-loading.vue\";\r\nexport default {\r\n    components: {\r\n        full_loading: full_loading,\r\n    },\r\n    name: 'nafath_verification_modal',\r\n    props: {\r\n    },\r\n    data() {\r\n        return {\r\n            global,\r\n                helper,\r\n                frappe,\r\n            is_loading: false,\r\n            error: false,\r\n            national_id:\"\",\r\n            random:null,\r\n            attachment:null,\r\n            imageUrl:null,\r\n            filename:null,\r\n            filetype:null,\r\n            onsuccess_func:null\r\n        }\r\n    },\r\n    mounted() {\r\n        global.emitter.on(\"set-onsuccess-func\", (args) => {\r\n            onsuccess_func = args;\r\n        });\r\n        global.emitter.on(\"set-national-id\", (args) => {\r\n            this.national_id = args;\r\n        });\r\n        var exampleModal = document.getElementById('nafaz-verification-modal');\r\n        exampleModal.addEventListener('show.bs.modal', ()=>{\r\n            // this.national_id = \"\";\r\n            this.random = null;\r\n        });\r\n    },\r\n    methods: {\r\n        verify_nafaz: async function (){\r\n            if(this.national_id.length != 10 || !(/^\\d+$/.test(this.national_id)) ){\r\n                helper.showException(\"Enter valid National Id\");\r\n                return;\r\n            }\r\n            if(this.is_loading){\r\n                return;\r\n            }\r\n            this.loading = true;\r\n            global.emitter.emit(\"show-full-loading\");\r\n            let params = {\r\n                national_id: this.national_id,\r\n            };\r\n            try {\r\n                let res = await $.ajax({\r\n                    headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                    url: \"/api/method/maalek.api.verify_nafath\",\r\n                    type: \"POST\",\r\n                    // data: params //for GET request\r\n                    data: JSON.stringify(params) //for POST request\r\n                });\r\n                global.emitter.emit(\"hide-full-loading\");\r\n                this.random = res.message\r\n                var status = \"WAITING\"\r\n                do{\r\n                    res = await $.ajax({\r\n                        headers: { 'X-Frappe-CSRF-Token': frappe.csrf_token },\r\n                        url: \"/api/method/maalek.api.verify_nafath_wait\",\r\n                        type: \"GET\",\r\n                        data: {} //for GET request\r\n                    });\r\n                    status = res.message\r\n                }while(status == \"WAITING\");\r\n                this.loading = false\r\n                this.error = false;\r\n                $(\"#nafaz-verification-modal\").modal('hide');\r\n                helper.showSuccess(\"Nafath verification is successful.\",onsuccess_func);\r\n            } catch (e) {\r\n                this.error = true;\r\n                helper.showException(e,()=>{\r\n                    $(\"#nafaz-verification-modal\").modal('hide');\r\n                });\r\n            }\r\n            global.emitter.emit(\"hide-full-loading\");\r\n            this.loading = false\r\n        },\r\n        onPickFile () {\r\n            this.$refs.fileInput.click()\r\n        },\r\n        onFilePicked (event) {\r\n            const files = event.target.files\r\n            if (files && files[0]) {\r\n                this.attachment = {};\r\n                this.attachment[\"file\"] = files[0].name\r\n                this.attachment[\"type\"] = files[0].type\r\n                const fileReader = new FileReader()\r\n                fileReader.readAsDataURL(files[0])\r\n                let reader = new FileReader;\r\n                reader.onload = e => {\r\n                    this.attachment[\"data\"] = e.target.result;\r\n                }\r\n                reader.readAsDataURL(files[0]);\r\n                this.$forceUpdate();\r\n            }\r\n        }\r\n    },\r\n    computed: {\r\n    }\r\n}\r\n</script>\r\n\r\n<style>\r\n    .modal-content{\r\n        overflow: visible !important;\r\n    }\r\n</style>\r\n"]}, media: undefined })

  }
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "../maalek/maalek/public/vue/modal/nafath-verification.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (true) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  function __vue_create_injector__() {
    const styles = __vue_create_injector__.styles || (__vue_create_injector__.styles = {})
    const isOldIE =
      typeof navigator !== 'undefined' &&
      /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase())

    return function addStyle(id, css) {
      if (document.querySelector('style[data-vue-ssr-id~="' + id + '"]')) return // SSR styles are present.

      const group = isOldIE ? css.media || 'default' : id
      const style = styles[group] || (styles[group] = { ids: [], parts: [], element: undefined })

      if (!style.ids.includes(id)) {
        let code = css.source
        let index = style.ids.length

        style.ids.push(id)

        if (false && css.map) {
          // https://developer.chrome.com/devtools/docs/javascript-debugging
          // this makes source maps inside style tags work properly in Chrome
          code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'
          // http://stackoverflow.com/a/26603875
          code +=
            '\n/*# sourceMappingURL=data:application/json;base64,' +
            btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) +
            ' */'
        }

        if (isOldIE) {
          style.element = style.element || document.querySelector('style[data-group=' + group + ']')
        }

        if (!style.element) {
          const head = document.head || document.getElementsByTagName('head')[0]
          const el = style.element = document.createElement('style')
          el.type = 'text/css'

          if (css.media) el.setAttribute('media', css.media)
          if (isOldIE) {
            el.setAttribute('data-group', group)
            el.setAttribute('data-next-index', '0')
          }

          head.appendChild(el)
        }

        if (isOldIE) {
          index = parseInt(style.element.getAttribute('data-next-index'))
          style.element.setAttribute('data-next-index', index + 1)
        }

        if (style.element.styleSheet) {
          style.parts.push(code)
          style.element.styleSheet.cssText = style.parts
            .filter(Boolean)
            .join('\n')
        } else {
          const textNode = document.createTextNode(code)
          const nodes = style.element.childNodes
          if (nodes[index]) style.element.removeChild(nodes[index])
          if (nodes.length) style.element.insertBefore(textNode, nodes[index])
          else style.element.appendChild(textNode)
        }
      }
    }
  }
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  )

  export default __vue_component__